import React from "react";
import { PropsWithChildren } from "react";

export const DefaultAuthenticationWrapperComponent: React.FC<
    PropsWithChildren
> = (props) => {
    return <div>{props?.children}</div>;
};
